import { StudentsUIProvider } from "./StudentsUIContext";
import { StudentsCard } from "./StudentsCard";

export function StudentsPage({
  currentTerm,
  currentSectionId,
  newTerm,
  newSectionId
}) {
  return (
    <StudentsUIProvider studentsUIParameters={{ currentTerm, currentSectionId, newTerm, newSectionId }}>
      <StudentsCard />
    </StudentsUIProvider>
 );
}